import React from 'react';
import { makeStyles } from "@mui/styles";
import { Checkbox } from '@mui/material';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
// import WorkstationStatus from './WorkstationStatus';
import { toLowerAndCapitalizeFirstLetter } from '../../Helpers/generalHelper';
import { Printer, ScanBarcode } from 'lucide-react';

//workstation tile in the workstation overview
export default function WorkstationTile(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    let boxShadow = "";
    let cursor = "";

    let disabled = "";
    if (props.active) {
        boxShadow = "0 0 7px " + FlagstoneTheme.palette.primary.main;
    }
    if (props.active === false && props.maximumSelected === true) {
        cursor = "not-allowed";
        disabled = "0.4";
    } else {
        cursor = "pointer";

    }

    return (
        <div className={classes.workstation} disabled={disabled} style={{ boxShadow: boxShadow, cursor: cursor, opacity: disabled }}
            onClick={() => props.activateWorkstation(props.workstation.Id)}>
            <div className={classes.line}>
                {t("Checkpoint")}
            </div>
            <div className={classes.lineId}>
                {props.workstation.Name}
            </div>
            {props.workstation.activeUserFirstName ? <div className={classes.activeUser}>
                {toLowerAndCapitalizeFirstLetter(props.workstation.activeUserFirstName) + " " + toLowerAndCapitalizeFirstLetter(props.workstation.activeUserLastName)}
            </div> : <div className={classes.activeUser}>
            </div>}
            <div className={classes.line}>
                {props.workstation.WorkstationTypeId === 1 ? <ScanBarcode className={classes.tileIcon}></ScanBarcode> : <Printer className={classes.tileIcon}></Printer>}
            </div>
            {/* <WorkstationStatus {...props} hasActiveOrders={true} iconSize={"35px"} height={"60px"} statusFontSize={"14px"} foamyFontSize={"14px"} borderColor={FlagstoneTheme.palette.grey.main} iconWidth={"20%"} statusWidth={"80%"} workstation={props.workstation}></WorkstationStatus> */}
            <div className={classes.checkboxContainer}>
                <div className={classes.checkboxDiv}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        checked={props.active}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                        onChange={() => props.activateWorkstation(props.workstation.Id)}
                    />
                </div>
            </div>
        </div>
    )
}

const useStyles = makeStyles(() => ({

    line: {
        color: "#0C0E29",
        opacity: "0.8",
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        marginBottom: '4px'
    },
    activeUser: {
        color: "#0C0E29",
        opacity: "0.8",
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingBottom: "10px",
        height: "20px"
    },
    lineId: {
        color: "#0C0E29",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingBottom: "12px"
    },
    stateIcon: {
        float: "left"
    },
    tileIcon: {
        float: "center",
        width: "80px",
        height: "80px"
    },
    workstation: {
        backgroundColor: "white",
        borderRadius: "6px",
        padding: "16px",
    },
    checkboxContainer: {
        width: "200px",
        textAlign: "center"
    },
    checkboxDiv: {
        width: "50px",
        marginLeft: "auto",
        marginRight: "auto"
    },
    checkBox: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        marginTop: "3px"
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
    }
}));